import createRoute       from '@widesk-ui/tools/createRoute';
import CancelReasonModel from '@models/shop/CancelReasonModel';

export default createRoute.dashboard('/cancel_reasons', 'shop', 'CancelReasonDashboard', CancelReasonModel.localize());